export enum RoleTypes {
  RoleEmployee = 'ROLE_EMPLOYEES',
  RoleDWH = 'ROLE_DWH_ACCESS',
  RoleHR = 'ROLE_HR',
  RoleSales = 'ROLE_SALES',
  RoleAccounting = 'ROLE_ACCOUNTING',
  RoleDEVHR = 'ROLE_DEVHR',
  RoleAdministration = 'ROLE_ADMINISTRATION',
}
